import { Component } from '@angular/core';
import { ChangeControlLibraryConstants } from '../../constants/changeControlLibraryConstants';
import { LabelConstants } from '../../../../shared/constants/label-constants';
import { ChangeManagementAuthorization } from '../../models/change-management-authorization';
import { ChangeControlService } from '../../services/changecontrol.service';
import { ChangecontrolPersistenceService } from '../../services/changecontrol-persistence.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-change-control-library',
  templateUrl: './change-control-library.component.html',
  styleUrls: ['./change-control-library.component.scss'],
})
export class ChangeControlLibraryComponent {
  topBarTitle: string = ChangeControlLibraryConstants.ChangeControlLibraryTitle;
  isScreenAccessible: boolean = true;
  errorMessage!: string;
  changeControlLookUpData!: ChangeManagementAuthorization;
  isChangeControlSliderOpen = false;
  changeControlLoader: boolean = false;

  constructor(private changeControlService: ChangeControlService, private changeControlPersistenceService: ChangecontrolPersistenceService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {    
    this.changeControlPersistenceService.toastMessage$
    .subscribe(message => {
      this.messageService.add(message);
    });
    this.changeControlService.changeManagementAuthorization().subscribe({
      error: (err: any) => {
        if (err.status === LabelConstants.Forbidden_StatusCode) {
          this.errorMessage = err.error.detail;
        }
        this.isScreenAccessible = false;
      },
      next: (serviceData: ChangeManagementAuthorization) => {
        if (serviceData.changeManagementAvailable) {
          this.changeControlLookUpData = serviceData;
        } else {
          this.errorMessage =
          ChangeControlLibraryConstants.ChangeControl_Page_Validation;
          this.isScreenAccessible = false;
        }
      },
    });
  }

  addChangeControl(): void {
    this.isChangeControlSliderOpen = true;
  }

  closeChangeControlSlider(isSliderActive: boolean) {
    this.isChangeControlSliderOpen = isSliderActive;
  }
}
